var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrScanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3377 5.67969H6.10547V13.9119M42.892 13.9119V5.67969H34.6598M34.6598 42.4662H42.892V34.234M11.1263 26.4691V37.4056H22.0629V26.4691H11.1263ZM14.3278 29.6705H18.9012V34.2439H14.3278V29.6705ZM11.1263 10.7006V21.6371H22.0629V10.7006H11.1263ZM14.3278 13.902H18.9012V18.4754H14.3278V13.902ZM26.8948 10.7006V21.6371H37.8314V10.7006H26.8948ZM30.0963 13.902H34.6697V18.4754H30.0963V13.902ZM32.383 37.4454C33.7468 37.1873 34.9717 36.446 35.833 35.3575C37.2008 33.784 37.9281 31.7545 37.8711 29.6705V26.4691H26.9346V29.6705C26.8805 31.7541 27.6075 33.7826 28.9728 35.3575C29.8241 36.4379 31.0336 37.1784 32.383 37.4454Z",
    stroke: "#F83758",
    strokeWidth: 1.98846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10547 34.2276V42.4598H14.3377M32.383 34.2375C31.9923 33.9963 31.6318 33.7092 31.3092 33.3825C30.4517 32.3396 30.0186 31.012 30.0963 29.6641H34.6697C34.7446 31.0133 34.3079 32.3411 33.4468 33.3825C33.1242 33.7092 32.7637 33.9963 32.373 34.2375H32.383Z",
    stroke: "#F83758",
    strokeWidth: 1.98846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScanner);
export default __webpack_public_path__ + "static/media/qrScanner.7a19c02cc9a641dedb238ec4a0a0d377.svg";
export { ForwardRef as ReactComponent };